/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './post-op-surgeon-notes.reducer';

export const PostOPSurgeonNotesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const postOPSurgeonNotesEntity = useAppSelector(state => state.postOPSurgeonNotes.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="postOPSurgeonNotesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.detail.title">PostOPSurgeonNotes</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.id">Id</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.id}</dd>
          <dt>
            <span id="preOpDiagnosis">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.preOpDiagnosis">Pre Op Diagnosis</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.preOpDiagnosis}</dd>
          <dt>
            <span id="postOpDiagnosis">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.postOpDiagnosis">Post Op Diagnosis</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.postOpDiagnosis}</dd>
          <dt>
            <span id="diagnosisDiscrepancy">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.diagnosisDiscrepancy">Diagnosis Discrepancy</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.diagnosisDiscrepancy}</dd>
          <dt>
            <span id="discrepancyNotes">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.discrepancyNotes">Discrepancy Notes</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.discrepancyNotes}</dd>
          <dt>
            <span id="incision">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.incision">Incision</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.incision}</dd>
          <dt>
            <span id="findings">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.findings">Findings</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.findings}</dd>
          <dt>
            <span id="procedure">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.procedure">Procedure</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.procedure}</dd>
          <dt>
            <span id="complications">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.complications">Complications</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.complications ? 'true' : 'false'}</dd>
          <dt>
            <span id="complicationNotes">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.complicationNotes">Complication Notes</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.complicationNotes}</dd>
          <dt>
            <span id="closure">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.closure">Closure</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.closure}</dd>
          <dt>
            <span id="recovery">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.recovery">Recovery</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.recovery}</dd>
          <dt>
            <span id="specciman">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.specciman">Specciman</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.specciman}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.active">Active</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{postOPSurgeonNotesEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.surgery">Surgery</Translate>
          </dt>
          <dd>{postOPSurgeonNotesEntity.surgery ? postOPSurgeonNotesEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{postOPSurgeonNotesEntity.anaesthesiologist ? postOPSurgeonNotesEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.surgeon">Surgeon</Translate>
          </dt>
          <dd>{postOPSurgeonNotesEntity.surgeon ? postOPSurgeonNotesEntity.surgeon.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.scrubNurse">Scrub Nurse</Translate>
          </dt>
          <dd>{postOPSurgeonNotesEntity.scrubNurse ? postOPSurgeonNotesEntity.scrubNurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/post-op-surgeon-notes" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/post-op-surgeon-notes/${postOPSurgeonNotesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PostOPSurgeonNotesDetail;
